kv.controller('FeeStatisticsReportShowCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
    var data = JSON.parse(vm.bladeParams.data);
    let initParams = kvUtils.getAllQueryParams();

    if (initParams) {
        if (initParams.generate) {
            $('[href="#results-tab"]').tab("show");
        }
    }

    vm.drillDown = function(group_by, agg_id) {
        let params = angular.copy(initParams);
        params[params.group_by + "_id"] = agg_id;
        params.group_by = group_by;

        let url = window.location.origin + window.location.pathname + "?" + $filter("objToParams")(params);
        window.open(url);
    };

    $(document).ready(function() {
        $('#table').DataTable({
            fixedHeader: {
                header: false,
                footer: true
            },
            "bPaginate": false,
            "paging":   false,
            "ordering": true,
            "info":     false,
            "bLengthChange": false
        });

        $('.dataTables_filter input[type="search"]').
            attr('placeholder','Search in table...').
            removeClass('input-small').
            addClass('no-print').
            css({'width':'350px','display':'inline-block'});

        $('.dataTables_filter').addClass('pull-right').addClass('no-print');
    });

    vm.isLoading = true;

    var chartData = data[1];
    function chart() {
        $('#feeStatisticsReportChart').hide();
        var config = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                events: {
                    load: function () {
                        this.reflow();
                    }
                },
                height: 550,
            },
            title: {
                text: ''
            },
            tooltip: {
                headerFormat: '',
                pointFormat: '{point.name}: <b>{point.y} ({point.percentage:.1f})%</b>'
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    innerSize: '60%',
                    dataLabels: {
                        enabled: true,
                        style: {
                            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                        }
                    },
                    showInLegend: false
                }
            },
            series: [{
                data: chartData
            }],
            afterPrint: function(a,b,c) {
                console.log(a,b,c)
            }
        }

        // hide dataLabels when resolution is xxs (phone)
        if( $(window).width() < 480 )
        {
          config.plotOptions.pie.dataLabels.enabled = false
        }
        $('#feeStatisticsReportChart').highcharts(config);
        vm.isLoading = false;

        setTimeout(function() {
            $('#feeStatisticsReportChart').show();
            $('#feeStatisticsReportChart').highcharts().reflow();
        }, 1);
    }

    if (chartData) {
        chart();
    }

	return vm;
});
